export const tableHeaders = [
  {
    id: 1,
    label: 'Start date',
    intlKey: 'table.start_date',
    sortable: false
  },
  {
    id: 2,
    label: 'End date',
    intlKey: 'table.end_date',
    sortable: false
  },
  {
    id: 4,
    label: 'Completed',
    intlKey: 'table.completed',
    sortable: false
  }
]
